import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const loc = useLocation();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams((loc.hash || "").replace(/^#/, ""));
    const sid = params.get("session_id");
    if (!sid) {
      nav("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", null, {
          headers: { "X-Session-ID": sid },
        });
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        const dest =
          data.role === "admin" ? "/admin"
          : data.role === "affiliate" ? "/affiliate"
          : "/account";
        nav(dest, { replace: true });
      } catch {
        nav("/login?err=google", { replace: true });
      }
    })();
  }, [loc.hash, nav, setUser]);

  return (
    <div className="mx-auto max-w-md px-6 py-24 page-enter" data-testid="auth-callback">
      <div className="overline mb-3 animate-pulse">Signing you in…</div>
      <div className="font-display text-3xl leading-none">Almost there.</div>
      <p className="text-sm text-zinc-500 mt-4">Finishing the handshake with Google. This should take just a moment.</p>
    </div>
  );
}
